import { MessageCircle, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY, whatsappUrl } from "@/lib/contact";

export function Contact() {
  return (
    <section id="contact" className="py-24 sm:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-glow" />
      <div className="absolute inset-0 grid-pattern opacity-30" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-sm font-medium text-accent uppercase tracking-widest">
              Contact
            </span>
            <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
              Ready to start the clean energy revolution?
            </h2>
            <p className="mt-4 text-muted-foreground text-lg max-w-lg">
              Reach out today — our team will help you size, plan and install the right solar
              solution for your home or business.
            </p>

            <div className="mt-10 flex flex-wrap gap-3">
              <Button asChild size="lg" className="h-12 px-6 shadow-glow">
                <a
                  href={whatsappUrl(
                    `Hello ${COMPANY.name}, I'd like to talk about a solar project.`,
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MessageCircle className="w-4 h-4 mr-2" />
                  WhatsApp Us
                </a>
              </Button>
              <Button asChild size="lg" variant="outline" className="h-12 px-6">
                <a href={`mailto:${COMPANY.email}`}>
                  <Mail className="w-4 h-4 mr-2" />
                  Email Us
                </a>
              </Button>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {[
              { icon: Phone, label: "WhatsApp", value: COMPANY.whatsappDisplay },
              { icon: Mail, label: "Email", value: COMPANY.email },
              { icon: MapPin, label: "Location", value: COMPANY.location },
              { icon: MessageCircle, label: "BRN", value: COMPANY.brn },
            ].map((c) => (
              <div
                key={c.label}
                className="p-5 rounded-2xl bg-card border border-border backdrop-blur"
              >
                <c.icon className="w-5 h-5 text-accent" />
                <div className="mt-3 text-xs uppercase tracking-widest text-muted-foreground">
                  {c.label}
                </div>
                <div className="mt-1 font-medium text-foreground wrap-break-word">{c.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
